<app-auth-navbar></app-auth-navbar>
<div class="row m-0">
    <div class="col-lg-4 col-md-6 col-12 mx-auto" style="margin-top: 140px;">
        <form #resetForm="ngForm" (ngSubmit)="resetPassword(resetForm)">
            <h3 class="signin_heading custom-heading text-center">Reset your password</h3>
            <br>
            <div class="form-group my-4">
                <input [(ngModel)]="email" ngModel readonly type="email" name="email" class="input_figma sm-16 form-control" required
                    placeholder="Email">
            </div>
            <div class="form-group my-4 d-flex align-items-center">
                <input #password="ngModel" ngModel type="password" name="password" class="input_figma sm-16 form-control" required
                    placeholder="Enter a new password">
                                        <i class="far fa-eye cursor-pointer color-blue" style="margin-left:-2rem" (click)="showPassword($event)"></i>

            </div>
            <div class="form-group my-4 d-flex align-items-center">
                <input #confirm="ngModel" ngModel type="password" class="input_figma sm-16 form-control" name="password_confirmation" required
                    placeholder="Re-enter your new password">
                                        <i class="far fa-eye cursor-pointer color-blue" style="margin-left:-2rem" (click)="showPassword($event)"></i>

            </div>
            <p *ngIf="password.value!=confirm.value && password.dirty && confirm.dirty" class="text-danger">Password do not match</p>
            <button [disabled]="!resetForm.valid" type="submit" class="btn primary-btn reset__btn2 w-100 button_figma border-0">Reset my password</button>
        </form>
    </div>
</div>